import isNil from 'lodash-es/isNil';

import { getAnnualPlan } from '~/src/common/brooklyn';

import { usePlan } from './usePlan';

export function useAnnualPrice() {
  const { error, loading, plan } = usePlan(getAnnualPlan);

  const annualPricePerMonth = plan?.monthlyDisplayPrice() ? plan?.monthlyDisplayPrice() : null;
  const annualPrice = plan?.displayPrice() ? plan?.displayPrice() : null;

  const errorMsg = loading
    ? null
    : error
    ? error
    : isNil(annualPricePerMonth)
    ? 'Price is unavailable'
    : null;

  return {
    price: annualPrice,
    pricePerMonth: annualPricePerMonth,
    loading,
    error: errorMsg,
  };
}
